import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { ROUTE_LOGIN } from '../../navigation/constants';
import { isUserLoggedIn } from '../auth/selectors';

function Authentication({ children, isUserLoggedIn }) {
    const isInviteAvailable = localStorage.getItem('invite');
    if (
        isInviteAvailable &&
        isUserLoggedIn &&
        !window.location.pathname.startsWith('/invite')
    ) {
        return (
            <Fragment>
                <Redirect
                    to={{
                        pathname: isInviteAvailable,
                    }}
                />
            </Fragment>
        );
    }

    return (
        <Fragment>
            {isUserLoggedIn ? (
                children
            ) : (
                <Redirect
                    to={{
                        pathname: ROUTE_LOGIN,
                    }}
                />
            )}
        </Fragment>
    );
}

Authentication.propTypes = {
    // denotes whether the current user is logged in or not
    isUserLoggedIn: PropTypes.bool,

    // components to be rendered if authenicated
    children: PropTypes.node.isRequired,
};

Authentication.defaultProps = {
    isUserLoggedIn: false,
};

const mapStateToProps = (state) => {
    return {
        isUserLoggedIn: isUserLoggedIn(state),
    };
};

const ConnectedAuthentication = connect(mapStateToProps)(Authentication);

export default ConnectedAuthentication;
